import { ChargePointUser } from '../common/redux/api/web-api'

const canChangePassword = (currentUser: ChargePointUser, selectedUser?: ChargePointUser): boolean => {
    if (!selectedUser) {
        return false
    }

    if (!selectedUser.id) {
        return false
    }

    if (currentUser.id === selectedUser.id) {
        return true
    }

    if (currentUser.isSuperAdmin) {
        return true
    }

    return false
}

export default canChangePassword
